import React from "react";
import { t } from "i18next";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  IconButton,
  Button,
  Menu,
} from "@mui/material";
import { CachedIcon, SearchIcon } from "../../icons/index.tsx";
import InspLabelDetailFilter from "./InspLabelDetailFilter.js";

export default function ReportFilterMenu({
  openDetailFilter,
  setOpenDetailFilter,
  filterIconRef,
  selectedIp,
  handleSelectedIpChange,
  clientIps,
  inputMaterial,
  setInputMaterial,
  selectAvi,
  selectAi,
  selectHr,
  setSelectAvi,
  setSelectAi,
  setSelectHr,
  handleApplyFilter,
  setIsFilter,
  filterModalStyle,
  siteData,
}) {
  const filter = siteData?.filter;
  return (
    <Menu
      open={openDetailFilter}
      onClose={() => {
        setOpenDetailFilter(false);
        setSelectAvi("");
        setSelectAi("NG");
        setSelectHr("");
      }}
      anchorEl={filterIconRef.current}
    >
      <Box sx={filterModalStyle}>
        {filter && filter.ip && (
          <FormControl sx={{ width: "200px" }}>
            <InputLabel>IP</InputLabel>
            <Select
              value={selectedIp}
              onChange={(e) => handleSelectedIpChange(e)}
            >
              <MenuItem value="ALL">전체</MenuItem>
              {clientIps.map((ip, index) => (
                <MenuItem key={index} value={ip.client_ip}>
                  {ip.client_ip}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {filter && filter.ip && (
          <FormControl
            fullWidth
            sx={{
              border: "1px solid lightgray",
              mt: 2,
              alignItems: "center",
              display: "flex",
              width: "200px",
            }}
          >
            <InputLabel>
              <SearchIcon /> Material
            </InputLabel>
            <Input
              value={inputMaterial}
              onChange={(e) => {
                setInputMaterial(e.target.value);
              }}
            />
          </FormControl>
        )}

        <InspLabelDetailFilter
          selectAvi={selectAvi}
          selectAi={selectAi}
          selectHr={selectHr}
          setSelectAvi={setSelectAvi}
          setSelectAi={setSelectAi}
          setSelectHr={setSelectHr}
          filter={filter}
        />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            onClick={() => {
              setSelectAvi("");
              setSelectAi("");
              setSelectHr("");
              setIsFilter(false);
            }}
            title="필터 초기화"
          >
            <CachedIcon />
          </IconButton>
          <Button
            style={{ marginTop: "10px", color: "var(--button-color)" }}
            onClick={() => {
              handleApplyFilter();
              setOpenDetailFilter(false);
            }}
          >
            {t("Apply")}
          </Button>
        </div>
      </Box>
    </Menu>
  );
}
